export const SET_SELECTED_COMMESSA = 'setSelectedCommessa';